<p-card>
    <form [formGroup]="accountTypeForm">
      <!-- <div class="formgrid grid"> -->
        <!-- Save Button -->
        <div class="flex align-items-start" style="margin-bottom: 15px;">
          <div>
            <p-button label="Save" class="p-button-outlined ml-2" icon="pi pi-save" size="small"
              (click)="createAccountGroup()"></p-button>
          </div>
        </div>
        <div class="formgrid grid">
        <!-- Account Group Code Field -->
        <div class="col">
          <div class="field text-left" style="display: flex; flex-direction: column; align-items: flex-start;">
            <label for="website">Account Type Code</label>
            <div style="display: flex; align-items: center;">
              <input type="text" pInputText placeholder="e.g AG89098" (blur)="checkAccountTypeCode()" class="w-full"
                formControlName="AccountTypeCode" [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.AccountTypeCode.errors }" />
              <div style="margin-left: 10px;">
                <p-checkbox formControlName="manualEntry" (onChange)="manualEntry()" [binary]="true"
                  label="Manual Entry" value="true"></p-checkbox>
              </div>
            </div>
            <small *ngIf="submitted && formControls.AccountTypeCode.errors" class="text-red-500">Required field.</small>
          </div>
        </div>
  
        <!-- Account Group Name Field -->
        <div class="col">
          <div class="field text-left">
            <label for="website">Account Type Name</label>
            <input pInputText placeholder="e.g Tom Hank" class="w-full"
              formControlName="AccountType" [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.AccountType.errors }" />
            <small *ngIf="submitted && formControls.AccountType.errors" class="text-red-500">Required field.</small>
          </div>
        </div>
  
        <!-- Account Group Description Field -->
        <div class="col">
          <div class="field text-left">
            <label for="website">Account Type Description</label>
            <input pInputText class="w-full" formControlName="AccountTypeDescription" />
          </div>
        </div>
      </div>
    </form>
  </p-card>
  